import confetti, { Options, Shape } from 'canvas-confetti';

// list of the d attribute from the svg paths
const CONFETTI_SHAPES = [
  'M55.7715 21.5356L12.9107 42.9523C12.9107 42.9523 26.5359 99.1965 59.6515 115.156C92.767 131.115 111.955 119.816 141.512 105.047L113.046 47.6996C94.884 56.775 70.6828 75.4262 55.8146 21.5497L55.7715 21.5356Z',
  'M72.9771 35.6117C41.9578 43.1601 21.3069 45.9856 7.56348 43.8367L43.0661 120.896C54.8946 118.662 67.4826 115.807 81.0289 112.196C111.063 105.005 130.453 103.074 143.283 106.416L106.927 27.5052C96.2666 29.6648 85.0017 32.3282 72.9771 35.6117Z,',
  'M98.2785 57.6425C105.628 54.4497 107.273 45.9757 100.753 31.0074C100.051 29.3954 98.9451 27.9132 98.2429 26.3012L130.541 12.2695C132.204 14.9248 133.809 18.6093 135.915 23.4452C152.181 60.7892 142.355 86.282 118.219 96.768C100.232 104.582 87.0473 101.136 74.4146 95.5785C65.0356 91.8938 58.4422 89.0071 51.8665 91.8639C44.5172 95.0567 42.8556 103.492 49.3922 118.499L51.6825 123.757L19.7712 137.621C17.9414 134.582 16.3365 130.897 14.3973 126.445C-2.03616 88.7173 7.36426 63.4092 31.9263 52.7384C49.9127 44.9244 63.265 48.7543 75.7472 53.9663C85.1095 57.6126 91.7196 60.5377 98.2953 57.6809L98.2785 57.6425Z',
  'M65.2472 20.0442L20.8937 50.2201L17.5066 101.549L57.6258 135.401L111.062 126.266L137.558 81.0252L117.169 33.7612L65.2472 20.0442Z',
];

const randomInRange = (min: number, max: number): number => {
  const array = new Uint32Array(1);

  window.crypto.getRandomValues(array);

  const random = array[0] / (0xffffffff + 1);

  return random * (max - min) + min;
};

const getShapes = (): Shape[] => CONFETTI_SHAPES.map((shape) => confetti.shapeFromPath({ path: shape }));

export const showConfetti = (): void => {
  const options: Options = {
    colors: ['#ff5254', '#007bff', '#62ba47', '#ffc700', '#a451a6', '#f74d9c'],
    zIndex: 600,
    gravity: 1.5,
    shapes: getShapes(),
    origin: {
      y: 0.8,
    },
  };

  for (let i = 0; i < 4; i++) {
    confetti({
      ...options,
      particleCount: randomInRange(20, 70),
      spread: randomInRange(90, 180),
      scalar: randomInRange(1.9, 2.1),
      startVelocity: randomInRange(55, 85),
    });
  }
};
